import { render, staticRenderFns } from "./AppointmentBookingCalendar.vue?vue&type=template&id=8ec6cbce"
import script from "./AppointmentBookingCalendar.vue?vue&type=script&lang=js"
export * from "./AppointmentBookingCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports